import { useParams } from 'react-router';
import type { Area} from '~/common/types/area';
import { PgArea, TgArea } from '~/common/types/area';
import type { Language } from '~/common/types/language.ts';
import { useAreaLayoutLoaderData } from '~/common/utils/useAreaLayoutLoaderData';


/**
 * Hook to get the base path of the current route.
 */
export function useBasePath() {
  const areaLayoutLoaderData = useAreaLayoutLoaderData();
  const { lang, area } = useParams() as { lang: Language; area: Area };

  let currentLang = lang;
  let currentArea = area;

  if (areaLayoutLoaderData) {
    currentLang = areaLayoutLoaderData.lang ?? 'de';
    currentArea = areaLayoutLoaderData.area ?? TgArea;
  }

  const isAgh = currentArea === PgArea;
  const isBgh = currentArea === TgArea;

  return { path: `/${currentLang}/${currentArea}`, lang: currentLang, area: currentArea, isAgh, isBgh };
}
